import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for  list marketholidays
export const MarketholidayList = createSlice({
  name: "MarketholidayList",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_MarketholidayList: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_MarketholidayList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_MarketholidayList: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    MarketholidayList_is_first: (state, action) => {
      state.isFirst = false;
    },
    clearDataMarketholidayList: (state) => {
      state.data = [];
    },
  },
});
export default MarketholidayList.reducer;
export const {
  list_MarketholidayList,
  success_api_call_MarketholidayList,
  failure_api_call_MarketholidayList,
  MarketholidayList_is_first,
  clearDataMarketholidayList,
} = MarketholidayList.actions;
